import { Component, EventEmitter, inject, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { ToastrService } from 'ngx-toastr';
import { RoundoffSavingsService } from '../Interface & Service/round-off-savings/roundoff-savings.service';
import { RoundOffSaving, RoundOffSavingCreateRequest, RoundOffSavingReadByUserIdRequest, RoundOffSavingUpdateRequest } from '../Interface & Service/round-off-savings/roundoff-savings.interface';

@Component({
  selector: 'app-roundup-savings-enroll',
  templateUrl: './roundup-savings-enroll.component.html',
  styleUrls: ['./roundup-savings-enroll.component.css']
})
export class RoundupSavingsEnrollComponent {
  User = inject(UserLoginService).User();
  roundOffService = inject(RoundoffSavingsService);
  toastr = inject(ToastrService);
  @Output() roundOffAmountFetch = new EventEmitter<any>();
  ngOnInit(): void {
    this.fetchRoundOffByUserIdRequest.userId = this.User?.userId
    this.FetchRoundOffDetailsForUser(this.fetchRoundOffByUserIdRequest)
  }

  fetchRoundOffByUserIdRequest: RoundOffSavingReadByUserIdRequest = {
    userId: this.User.userId
  }
  userRoundOffDetails: RoundOffSaving | null = null;
  FetchRoundOffDetailsForUser(requestDTO: RoundOffSavingReadByUserIdRequest) {
    this.roundOffService.RoundOffSavings_ReadByUserId(requestDTO).subscribe({
      next: (res) => {
        if (res) {
          this.userRoundOffDetails = res;
        } else {
          this.userRoundOffDetails = null;
        }
        this.RoundOffForm.patchValue({
          RoundOffAmount: null
        })
        if (!this.userRoundOffDetails?.isActive) {
          this.showForm = true
        }
      },
      error: (err) => {
        console.error('Failed to fetch round-off details:', err);
        this.userRoundOffDetails = null;
      }
    });
  }

  RoundOffForm = new FormGroup({
    RoundOffAmount: new FormControl(0, [Validators.required, Validators.min(0)]),
  })

  selectAmount(amount: number) {
    this.RoundOffForm.controls.RoundOffAmount.setValue(amount);
  }

  onInputFocus() {
    if (this.RoundOffForm.controls.RoundOffAmount.value === 0) {
      this.RoundOffForm.controls.RoundOffAmount.markAsTouched();
    }
  }

  public SignUpRoundOff() {
    if (this.RoundOffForm.invalid) {
      this.RoundOffForm.controls.RoundOffAmount.markAsTouched();
      return;
    }
    this.roundOffCreateRequestDTO.roundOffAmount = this.RoundOffForm.controls.RoundOffAmount.value as number;
    if (this.roundOffCreateRequestDTO.roundOffAmount > 0) {
      this.RoundOffSavingCreate(this.roundOffCreateRequestDTO);
    } else {
      this.toastr.error('Please enter an amount greater than 0 to start saving.', 'Invalid Amount');
    }
  }

  roundOffCreateRequestDTO: RoundOffSavingCreateRequest = {
    userId: this.User.userId,
    roundOffAmount: 0,
    description: '',
    otherDetail1: '',
    otherDetail2: '',
    otherDetail3: '',
    otherDetail4: '',
    otherDetail5: '',
    otherDetail6: '',
    actionUser: this.User.userId.toString()
  }
  RoundOffSavingCreate(requestDTO: RoundOffSavingCreateRequest) {
    this.roundOffService.RoundOffSavings_Create(requestDTO).subscribe({
      next: (res: RoundOffSaving) => {
        if (res) {
          this.userRoundOffDetails = res;
          this.toastr.success(`🎉 ₹${res.roundOffAmount.toFixed(2)} saved! Your journey to smart savings begins today.`);
          this.RoundOffForm.reset()
          this.roundOffAmountFetch.emit(res);
        }
      },
      error: (err) => {
        console.error(' Failed to fetch product type:', err);
      }
    });
  }

  unenrollRoundOff() {
    const updateDTO: RoundOffSavingUpdateRequest = {
      roundOffSavingId: this.userRoundOffDetails?.roundOffSavingId as number,
      userId: this.userRoundOffDetails?.userId as number,
      roundOffAmount: this.userRoundOffDetails?.roundOffAmount || 0,
      description: this.userRoundOffDetails?.description || '',
      otherDetail1: this.userRoundOffDetails?.otherDetail1 || '',
      otherDetail2: this.userRoundOffDetails?.otherDetail2 || '',
      otherDetail3: this.userRoundOffDetails?.otherDetail3 || '',
      otherDetail4: this.userRoundOffDetails?.otherDetail4 || '',
      otherDetail5: this.userRoundOffDetails?.otherDetail5 || '',
      otherDetail6: this.userRoundOffDetails?.otherDetail6 || '',
      isActive: 0,
      actionUser: this.User.userId.toString()
    };
    this.roundOffService.RoundOffSavings_Update(updateDTO).subscribe({
      next: (res: RoundOffSaving) => {
        this.userRoundOffDetails = res;
        this.toastr.info(`💡 You've paused your Round-Off savings. Restart anytime to keep building your smart savings journey.`);
        this.RoundOffForm.reset()
        this.roundOffAmountFetch.emit(res);
      },
      error: (err) => console.error('Failed to update amount:', err)
    });
  }

  showForm: boolean = false
  ShowUpdateForm() {
    this.showForm = true
  }
  updateRoundOffAmount() {
    const amount = this.RoundOffForm.controls.RoundOffAmount.value as number;

    if (this.RoundOffForm.invalid || amount <= 0) {
      this.RoundOffForm.controls.RoundOffAmount.markAsTouched();
      return;
    }
    const updateDTO: RoundOffSavingUpdateRequest = {
      roundOffSavingId: this.userRoundOffDetails?.roundOffSavingId as number,
      userId: this.userRoundOffDetails?.userId as number,
      roundOffAmount: amount,
      description: this.userRoundOffDetails?.description || '',
      otherDetail1: this.userRoundOffDetails?.otherDetail1 || '',
      otherDetail2: this.userRoundOffDetails?.otherDetail2 || '',
      otherDetail3: this.userRoundOffDetails?.otherDetail3 || '',
      otherDetail4: this.userRoundOffDetails?.otherDetail4 || '',
      otherDetail5: this.userRoundOffDetails?.otherDetail5 || '',
      otherDetail6: this.userRoundOffDetails?.otherDetail6 || '',
      isActive: this.userRoundOffDetails?.isActive as number,
      actionUser: this.User.userId.toString()
    };


    this.roundOffService.RoundOffSavings_Update(updateDTO).subscribe({
      next: (res: RoundOffSaving) => {
        this.userRoundOffDetails = res;
        this.toastr.success(`Smart Vault amount updated to ${res.roundOffAmount}`);
        this.RoundOffForm.reset()
        this.roundOffAmountFetch.emit(res);
      },
      error: (err) => console.error('Failed to update amount:', err)
    });
  }
}
